import { Box, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import deDEFlag from '../../../assets/flags/de-DE.png';
import enGBFlag from '../../../assets/flags/en-GB.png';
import esESFlag from '../../../assets/flags/es-ES.png';
import frFRFlag from '../../../assets/flags/fr-FR.png';
import nlNLFlag from '../../../assets/flags/nl-NL.png';
import { setLocale } from '../../actions/localeActions';
import { track } from '../analytics';
import { usePrevious } from '../customHooks';
import { getLocalStorageItem } from '../safe-storage';

export const localeOptions = [
	{
		localeKey: 'en-gb',
		localeShort: 'en',
		flag: enGBFlag,
		name: 'English',
	},
	{
		localeKey: 'es-es',
		localeShort: 'es',
		flag: esESFlag,
		name: 'Español',
	},
	{
		localeKey: 'fr-fr',
		localeShort: 'fr',
		flag: frFRFlag,
		name: 'French',
	},
	{
		localeKey: 'nl-nl',
		localeShort: 'nl',
		flag: nlNLFlag,
		name: 'Dutch',
	},
	{
		localeKey: 'de-de',
		localeShort: 'de',
		flag: deDEFlag,
		name: 'Deutsch',
	},
];

const LocaleSelector = ({ locales, setLocale, reloadPageOnChange = false, ...props }) => {
	const prevLocale = usePrevious(locales.locale);

	const currentLang = getLocalStorageItem('locale');
	const browserLang = navigator.language.toLowerCase() || navigator.userLanguage.toLowerCase();

	if (browserLang !== 'en-gb') {
		if (currentLang === null) {
			//check that lang has not already been set manually by user

			//because the browser local could be formatted as 'fr' or 'fr-fr' or 'fr-ca' we need to check all 3 scenarios below

			if (localeOptions.some((el) => el.localeKey === browserLang)) {
				//check if (fr-fr = fr-fr) exists in localeOptions array
				setLocale(browserLang);
			} else if (
				localeOptions.some((el) => el.localeKey === browserLang + '-' + browserLang)
			) {
				//check if browserlang-browserlang (fr = fr-fr) exists in localeOptions array
				setLocale(browserLang + '-' + browserLang);
			} else if (localeOptions.some((el) => el.localeShort === browserLang.split('-')[0])) {
				//check if (fr = fr-ca) exists in localeOptions array
				setLocale(
					localeOptions.find((element) => {
						return element.localeShort === browserLang.split('-')[0];
					}).localeKey
				);
			}
		}
	}

	useEffect(() => {
		if (reloadPageOnChange && prevLocale && prevLocale !== locales.locale) {
			window.location.assign(window.location.href);
		}
	}, [locales.locale]);

	return (
		<SelectLocale
			id="navigation-locale-selector"
			setLocale={setLocale}
			value={locales.locale}
			onChange={({ target }) => {
				track('Set locale', {
					locale: target.value,
				});
				setLocale(target.value);
			}}
			{...props}
		/>
	);
};

export const SelectLocale = ({ id, labelId = '', value, onChange, label, ...props }) => {
	return (
		<Select
			id={id}
			labelId={labelId}
			value={value}
			onChange={onChange}
			label={label}
			{...props}
			sx={{ fontWeight: 400, ...props.sx }}
		>
			{localeOptions.map((opt) => (
				<MenuItem key={opt.localeKey} value={opt.localeKey} dense>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
						<img src={opt.flag} alt={opt.name} style={{ width: 20, height: 20 }} />
						<Typography variant="body1">{opt.name}</Typography>
					</Box>
				</MenuItem>
			))}
		</Select>
	);
};

const mapStateToProps = ({ locales }) => ({ locales });

const mapDispatchToProps = { setLocale };

export default connect(mapStateToProps, mapDispatchToProps)(LocaleSelector);
